var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_91_2869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 7.38625V7.99958C14.6658 9.4372 14.2003 10.836 13.3395 11.9875C12.4788 13.1389 11.2688 13.9812 9.89022 14.3889C8.5116 14.7965 7.03815 14.7475 5.68963 14.2493C4.3411 13.7511 3.18975 12.8303 2.40729 11.6243C1.62482 10.4183 1.25317 8.99163 1.34776 7.55713C1.44235 6.12263 1.99812 4.75714 2.93217 3.6643C3.86621 2.57146 5.1285 1.80984 6.53077 1.49301C7.93304 1.17619 9.40016 1.32114 10.7133 1.90625",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 2.66626L8 9.33959L6 7.33959",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_91_2869"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 -0.000427246)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.43b66e5b66bcdcc510ab8309a73288e4.svg";
export { ForwardRef as ReactComponent };